module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.productName),
      expression: "pageInfo.productName"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索商品"
    },
    domProps: {
      "value": (_vm.pageInfo.productName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "productName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'saveProduct'
        })
      }
    }
  }, [_vm._v("\n            新增商品\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "flex pd-250",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'saveProduct',
            query: {
              itemId: item.itemId
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      attrs: {
        "src": item.mainPicView,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1 ofh"
    }, [_c('div', {
      staticClass: "name fs-28 color-333"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "bot flex-between fs-28 color-999"
    }, [_c('div', [_vm._v("销售价：￥" + _vm._s(item.specialPrice))]), _vm._v(" "), _c('div', [_vm._v("库存：" + _vm._s(item.stockNum))])])])]), _vm._v(" "), _c('div', {
      staticClass: "bd-top item-bot"
    }, [_c('div', {
      staticClass: "fs-26 color-999 click",
      class: item.state == 0 ? 'text-center w100' : '',
      on: {
        "click": function($event) {
          return _vm.remove(item)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), (item.state != 0) ? _c('div', {
      staticClass: "btn-group flex"
    }, [_c('div', {
      staticClass: "btn click color-main",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'saveProduct',
            query: {
              itemId: item.itemId
            }
          })
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), (item.state == 1) ? _c('div', {
      staticClass: "btn click color-org",
      on: {
        "click": function($event) {
          return _vm.updateState(item, '确定要下架该商品吗？', 2)
        }
      }
    }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (item.state != 1 && item.state != 3) ? _c('div', {
      staticClass: "btn click color-org",
      on: {
        "click": function($event) {
          return _vm.updateState(item, '确定要上架该商品吗？', 1)
        }
      }
    }, [_vm._v("上架")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.state == 3) ? _c('div', {
      staticClass: "color-red fs-28 pb-20"
    }, [_vm._v("失败原因：" + _vm._s(item.checkReason))]) : _vm._e()])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b839f378","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/product/productList.vue
// module id = J3KW
// module chunks = 51